import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import packageJson from "../package.json";
import { App } from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

function checkForNewVersionAndClearCache() {
  const currentVersion = localStorage.getItem("appVersion");
  const newVersion = packageJson.version;
  if (currentVersion !== newVersion) {
    localStorage.clear();

    setTimeout(() => {
      window.location.reload();
    }, 0);

    localStorage.setItem("appVersion", newVersion);
  } else {
    console.log(
      `Current app version matches stored version (${newVersion}). No need to clear`
    );
  }
}

checkForNewVersionAndClearCache();

window.onload = () => {
  checkForNewVersionAndClearCache();
};

reportWebVitals();
